import { CookieSetOptions } from 'universal-cookie';

export const isLocal =
  window.location.host.includes('localhost') ||
  window.location.host.includes('127.0.0.1');
export const isProd = import.meta.env.VITE_RUN_ENV === 'PROD';

export const resourceAPIURL = import.meta.env.VITE_RESOURCE_API_URL;
export const authAPIURL = import.meta.env.VITE_AUTH_API_URL;
export const CDNURL = import.meta.env.VITE_CDN_URL;
export const fingotiCDNURL = import.meta.env.VITE_FINGOTI_CDN_URL;

export const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const stripePricingTable = import.meta.env.VITE_STRIPE_PRICING_TABLE;
export const aiAPIURL = import.meta.env.VITE_AI_API_URL;

export const applicationId =
  import.meta.env.VITE_FINGOTI_APPLICATION_ID ??
  '39853a77-4b6f-481d-9ec9-654ce8b06bb2';
export const pdOrgId =
  import.meta.env.VITE_PD_ORG_ID ?? '800cd8d4-a4af-4f8e-932e-5b48ec299330';

const cookieExpire = new Date();

cookieExpire.setMonth(cookieExpire.getMonth() + 1);

export const cookieSettings: CookieSetOptions = isLocal
  ? { sameSite: 'lax', secure: false, expires: cookieExpire }
  : { sameSite: 'lax', secure: true, expires: cookieExpire };
